/* Copyright (c) 2021-2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { CapacityBasedFeeTypeEnum } from "~/models/assignmentRule";

export const EnvironmentInitialState = {
  application: { id: "", name: "" },
  attachedServiceLevel: {
    serviceLevel: {
      capacityBasedFee: {
        defaultPercentage: "",
        maxPercentage: "",
        minPercentage: "",
      },
      id: "",
      index: 0,
      name: "",
    },
    capacityBasedFeeType: CapacityBasedFeeTypeEnum.DEFAULT_TYPE,
    capacityBasedPercentageFee: "",
    effectiveCapacityBasedPercentageFee: "",
  },
  billingRules: {
    incidents: {
      officeHours: {
        defaultPricePerHour: "",
        pricePerHour: "",
      },
      outsideOfficeHoursAfterMidnight: {
        defaultPricePerHour: "",
        pricePerHour: "",
      },
      outsideOfficeHoursBeforeMidnight: {
        defaultPricePerHour: "",
        pricePerHour: "",
      },
    },
    serviceRequests: {
      officeHours: {
        defaultPricePerHour: "",
        pricePerHour: "",
      },
      outsideOfficeHoursAfterMidnight: {
        defaultPricePerHour: "",
        pricePerHour: "",
      },
      outsideOfficeHoursBeforeMidnight: {
        defaultPricePerHour: "",
        pricePerHour: "",
      },
    },
  },
  customer: { id: "", name: "" },
  details: null,
  id: "",
  log: {
    modified: {
      author: "",
      time: "",
    },
  },
  name: "",
  removed: false,
  status: "",
  cfRepoPath: "",
  environmentStatus: {
    assignmentRule: { id: "", name: "" },
    log: {
      modified: {
        author: "",
        time: "",
      },
    },
    value: "",
  },
  generalMapping: false,
  synchronizedAt: "",
  timeline: { softLaunch: null, goLive: "", offboarding: null },
  type: "",
};
